/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".rootOverflow_36635d0a{overflow:auto}.item_36635d0a{height:30px}"}]);
export const rootOverflow = "rootOverflow_36635d0a";
export const item = "item_36635d0a";